(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cook-this-look"] && !Shopify.designMode) return;
  try {
    
  const ctlSection = document.querySelector('.ctl');
  if (ctlSection && new URLSearchParams(window.location.search).get('ctl') === '1') {
    ctlSection.classList.add('ctl--review');
    const reviewNote = ctlSection.querySelector('.ctl__review-note');
    if (reviewNote) reviewNote.hidden = false;
  }

  document.querySelectorAll('.ctl .price-item').forEach((price) => {
    price.textContent = price.textContent.replace(/\.00\b/g, '');
  });

  document.querySelectorAll('.ctl__products-wrap').forEach((wrap) => {
    const rail = wrap.querySelector('[data-ctl-rail]');
    if (!rail) return;
    wrap.querySelector('.ctl__arrow--prev')?.addEventListener('click', () => {
      rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' });
    });
    wrap.querySelector('.ctl__arrow--next')?.addEventListener('click', () => {
      rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["directory-product-rails"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-directory-rails]');
    if (!root) return;

    root.querySelectorAll('.directory-rail').forEach((rail) => {
      const track = rail.querySelector('[data-rail-track]');
      rail.querySelector('[data-rail-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .82, behavior: 'smooth' }));
      rail.querySelector('[data-rail-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' }));
    });

    const loadFilteredRail = async (track) => {
      const source = track.dataset.filterSource;
      if (!source || track.dataset.loaded) return;
      track.dataset.loaded = 'true';
      try {
        const response = await fetch(source);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const seen = new Set();
        const products = [];
        doc.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          const image = link.querySelector('img');
          const href = link.getAttribute('href');
          if (!image || !href || seen.has(href) || products.length >= 6) return;
          seen.add(href);
          products.push({ href, src: image.currentSrc || image.src, srcset: image.srcset, alt: image.alt || '' });
        });
        track.querySelector('[data-rail-loading]')?.remove();
        const viewAll = track.querySelector('.directory-rail__view-all');
        products.forEach((product) => {
          const card = document.createElement('a');
          card.className = 'directory-rail__card';
          card.href = product.href;
          card.setAttribute('aria-label', product.alt || 'View product');
          const image = document.createElement('img');
          image.className = 'directory-rail__image';
          image.src = product.src;
          if (product.srcset) image.srcset = product.srcset;
          image.alt = product.alt;
          image.loading = 'lazy';
          card.appendChild(image);
          track.insertBefore(card, viewAll);
        });
      } catch (error) {
        const loading = track.querySelector('[data-rail-loading]');
        if (loading) loading.textContent = 'Products are available through View all.';
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadFilteredRail(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '1800px 0px' });
    root.querySelectorAll('[data-filter-source]').forEach((track) => observer.observe(track));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const availabilityKey = 'filter.v.availability';
    const url = new URL(window.location.href);
    if (!url.searchParams.has(availabilityKey)) {
      url.searchParams.set(availabilityKey, '1');
      window.location.replace(url.toString());
      return;
    }

    const removeUnwantedFacets = () => {
      document.querySelectorAll('#main-collection-filters details, #main-collection-filters .mobile-facets__details, #main-collection-filters .facets__disclosure-vertical, #main-collection-filters .active-facets__button').forEach((facet) => {
        const label = (facet.querySelector('summary, .mobile-facets__summary')?.textContent || facet.textContent || '').trim().toLowerCase();
        if (label.includes('availability') || label.includes('pattern') || label.startsWith('vibe')) facet.remove();
      });
    };

    document.querySelectorAll('.bditk-lens--categories a').forEach((link) => {
    if (new URL(link.href).pathname === window.location.pathname) {
        link.setAttribute('aria-current', 'page');
        const allCategoryLink = document.querySelector('.bditk-lens--categories a[href*="/collections/all"]');
        if (window.location.pathname !== '/collections/all' && allCategoryLink) link.href = allCategoryLink.href;
      }
  });
  removeUnwantedFacets();
    new MutationObserver(removeUnwantedFacets).observe(document.getElementById('main-collection-filters') || document.body, { childList:true, subtree:true });
  })();
  const styleCollectionCards = () => {
    document.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
      const titleLinks = card.querySelectorAll('.card__heading a');
      if (!titleLinks.length) return;

      const fullTitle = Array.from(titleLinks).map((link) => link.getAttribute('data-bditk-full-title')).find(Boolean)
        || titleLinks[0].textContent.trim();
      const shortTitle = fullTitle.split('|')[0].trim();
      titleLinks.forEach((link) => {
        link.setAttribute('data-bditk-full-title', fullTitle);
        if (link.textContent.trim() !== shortTitle) link.textContent = shortTitle;
      });

/* .active-facets__button:not([href*="filter.v.availability"]) {
  display: none !important;
}

.facets__disclosure:has(summary[aria-label^="Availability"]),
  .mobile-facets__details:has(summary[aria-label^="Availability"]) {
    display: none !important;
  }

  #product-grid .card-information > .price {
  margin-top: 0.7rem !important;
  } */

/* .active-facets__button:not([href*="filter.v.availability"]) {
  display: none !important;
}

      */
      card.querySelectorAll('.price-item').forEach((price) => {
        const wholeDollarPrice = price.textContent.replace(/(\$\d[\d,]*)\.00\b/g, '$1');
        if (price.textContent !== wholeDollarPrice) price.textContent = wholeDollarPrice;
      });
    });
  };

  styleCollectionCards();
  const productGridContainer = document.querySelector('#ProductGridContainer');
  if (productGridContainer) {
    new MutationObserver(styleCollectionCards).observe(productGridContainer, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
